//TODO: Hvis attachment er afvist + vis alt indhold derfra
//TODO: Hvis 401 - log ud?


import angular from 'angular';

import '../../../services/contract';
import '../../../services/user';
import '../../../directives/file-data-model';

import '../contracts-upload-files';

angular.module('folkeuni').component('contractsListExpences', {
    templateUrl: '/shop-dist/templates/contracts-list-expences.html?c=' + window.cacheBurst,
    transclude: false,
    controller: function (Contract, User, $filter, $scope, $sce, $timeout, $element, $document, $window) {
        var $ctrl = this;
        $ctrl.contracts = [];
        $ctrl.expenseTypes = Contract.expenseTypes;
        $ctrl.contractsShowCancelled = false;
        $ctrl.showArchive = false;

        var today = new Date(),
            todayMonth = today.getMonth() > 6 ? "2" : "1",
            todayYear = String(today.getYear() - 1).substring(1, 3);

        $ctrl.filterOlderThanTwoTerms = Number(todayYear + todayMonth);


        $ctrl.resetExpense = function (contract) {
            contract.expenseAmount = null;
            contract.file = null;
            contract.dietEndDate = null;
            contract.dietEndTime = null;
            contract.dietStartDate = null;
            contract.dietStartTime = null;
        }

        $ctrl.getAttachmentsForCurrentContract = function (item) {
            var getAttachmentsForCurrentContract = [];
            for (var i in item.lines) {
                var currentLine = item.lines[i];
                for (var y in currentLine.attachments) {
                    var currentAttachment = currentLine.attachments[y];
                    currentAttachment.parent = currentLine;
                    getAttachmentsForCurrentContract.push(currentAttachment);
                }
            }
            return getAttachmentsForCurrentContract
        }

        $ctrl.toggleCanceled = function () {
            $ctrl.contractsShowCancelled = !$ctrl.contractsShowCancelled;
        }
        $ctrl.toggleArchive = function () {
            $ctrl.showArchive = !$ctrl.showArchive;
        }

        $ctrl.attachmentDelete = function (contractId, attachment) {

            if (confirm("Er du sikker på at du vil slette bilaget: " + attachment.typeName + "?")) {
                var attachmentObj = {
                    contractId: contractId,
                    id: attachment.id,
                    lineNo: attachment.parent.lineNo
                }

                Contract.attachmentDelete(attachmentObj).then(function (successResponse) {
                    var index = attachment.parent.attachments.indexOf(attachment);
                    attachment.parent.attachments.splice(index, 1);
                }, function (errorResponse) {
                    console.log("Error", errorResponse);
                });
            }
        }

        function resetExpense(item) {
            item.expenseTypeSelected = $ctrl.expenseTypes[0];
            item.expenseAmount = "";
            item.expenseLectureSelected = item.lines[0];
            item.expenseComment = "";
            item.expenseAmount = null;
            item.file = null;
            item.dietEndDate = null;
            item.dietEndTime = null;
            item.dietStartDate = null;
            item.dietStartTime = null;
        }

        $ctrl.expendFormExpand = function (expendItem, index) {
            //  expendItem.collapseDetails = true;
            expendItem.expenceFormOpen = true;
            $timeout(function () {
                $document.scrollToElementAnimated($element.find('form')[index], 100);
            }, 150);
        };

        //Expense btn cancel
        $ctrl.expenseCancel = function (item) {
            resetExpense(item);
            item.expenceFormOpen = false;
        };

        //Expense btn add more expenses
        $ctrl.expenseReportMore = function (item) {
            item.statusMessage = "Din udgift er nu gemt og registreret";
            item.expenseFormfade = true;
            item.notvisible = true;

            $timeout(function () {
                return $timeout(function () {
                    item.notvisible = false;
                }, 3000);
            })
                .then(function () {
                    return $timeout(function () {
                        item.expenseFormfade = false;
                        item.expenceFormOpen = false;
                        // reset status message and form
                        item.statusMessage = false;

                        resetExpense(item)
                        item.collapseDetails = true;
                    }, 1000);
                }).then(function () {
                    return $timeout(function () {
                        item.expenceFormOpen = true;
                    }, 1000);
                });
        };

        function scrollToContractStart(index) {
            var contractElement = document.getElementsByClassName("contract")[index];

            $document.scrollToElementAnimated(contractElement);
        }

        $ctrl.restrictInputDietStartDate = function (currentVal) {
            currentVal.dietStartDate = "";
            return false;
        }
        $ctrl.restrictInputDietEndDate = function (currentVal) {
            currentVal.dietEndDate = "";
            return false;
        }

        //Expense save and exit
        $ctrl.expenseSave = function (item, index, expandAfterSubmit) {
            var valid = true;
            item.errorMessage = null;
            var regExClock = RegExp('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');

            if (item.expenseTypeSelected.id == "HOTEL") {
                if (!item.expenseHotelInvoice && !item.expenseAmount) {
                    valid = false;
                    item.errorMessage = "Du har ikke udfyldt beløb";
                }
            } else if (item.expenseTypeSelected.id == "DIÆT") {
                if (!item.dietStartDate || !item.dietStartTime || !item.dietEndDate || !item.dietEndTime) {
                    valid = false;
                    item.errorMessage = "Dato og klokkeslæt er ikke udfyldt korrekt. Husk at klokkeslæt skal skrives med kolon, f.eks. 10<b>:</b>00";
                }
                else if (!regExClock.test(item.dietStartTime) || !regExClock.test(item.dietEndTime)) {
                    valid = false;
                    item.errorMessage = "Klokkeslæt er ikke valid, f.eks. 10<b>:</b>00";
                }

            } else if (!item.expenseAmount) {
                valid = false;
                item.errorMessage = "Du har ikke udfyldt beløb";
            }
            else if (isNaN(item.expenseAmount.replace(',', '.'))) {
                valid = false;
                item.errorMessage = "Du har ikke udfyldt et gyldigt beløb";
            }
            else if (item.expenseTypeSelected.id == '-1') {
                valid = false;
                item.errorMessage = "Du har ikke valgt type";
            }

            if (valid) {
                var fromDateFormatted = null,
                    toDateFormatted = null;

                if (item.dietStartDate && item.dietStartTime) {
                    if (item.dietStartTime.length === 4) {
                        item.dietStartTime = "0" + item.dietStartTime;
                    }

                    fromDateFormatted = item.dietStartDate.split('.').reverse().join('-') + "T" + item.dietStartTime;
                }
                if (item.dietEndDate && item.dietEndTime) {
                    if (item.dietEndTime.length === 4) {
                        item.dietEndTime = "0" + item.dietEndTime;
                    }
                    toDateFormatted = item.dietEndDate.split('.').reverse().join('-') + "T" + item.dietEndTime;
                }

                var expenseObj = {
                    amount: item.expenseTypeSelected.id == "DIÆT" ? null : item.expenseAmount ? item.expenseAmount.replace(',', '.') : 0,
                    amountType: item.expenseTypeSelected.id == "KØRSEL" ? "Km" : "DKK",
                    contractId: item.id,
                    createdDate: new Date(),
                    description: item.expenseComment ? item.expenseComment : null,
                    externalInvoice: item.expenseHotelInvoice ? true : false,
                    fromDate: fromDateFormatted, //Diæt
                    lineNo: item.expenseLectureSelected.lineNo,
                    label: item.expenseTypeSelected.label,
                    lectureDate: $filter('date')(item.expenseLectureSelected.startDate, "dd.MM.yyyy"),
                    toDate: toDateFormatted, //Diæt
                    type: item.expenseTypeSelected.id
                }


                if ((item.expenseTypeSelected.id == "DIÆT" && toDateFormatted != fromDateFormatted) || item.expenseTypeSelected.id != "DIÆT") {
                    item.expenseFormfade = true;
                    item.notvisible = true
                    expenseObj.typeName = Contract.attachmentTypeLookup(item.expenseTypeSelected.id);

                    if (item.file) {
                        item.fileUploadProgress = {
                            message: "Vent venligst mens vi uploader din fil.",
                            progress: 0
                        }
                    }

                    Contract.attachmentCreate(expenseObj, item.file).then(function (successResponse) {
                        if (item.fileUploadProgress) {
                            item.fileUploadProgress.message = "Din fil blev uploadet";
                            item.fileUploadProgress.success = true;
                            expenseObj.tempFileString = "Fil uploadet";
                        }
                        expenseObj.id = successResponse.id;
                        expenseObj.fileUrl = successResponse.fileUrl;

                        item.expenseLectureSelected.attachments.push(expenseObj);
                        item.statusMessage = "Din udgift er nu gemt og registreret";

                        if (expandAfterSubmit == 0) {
                            scrollToContractStart(index);

                            item.expenseFormfade = false;
                            item.expenceFormOpen = false;
                            item.notvisible = false;
                        }
                        else {
                            item.expenseFormfade = false;
                            item.expenceFormOpen = true;
                            item.notvisible = false;
                        }

                        item.fileUploadProgress = null;
                        // console.log("item",item);
                        resetExpense(item);

                        $timeout(function () {
                            item.statusMessage = false;
                            item.collapseDetapusgils = false;
                        }, 2500);
                    }, function (errorResponse) {
                        item.notvisible = false;
                        item.expenseFormfade = false;
                        item.errorMessage = $sce.trustAsHtml("Bilaget blev ikke uploadet, det må maks fylde 5mb.<br/>Fylder din fil mindre, er du meget velkommen til at kontakte os - så vil vi stå til assistance.");
                    }, function (progress) {
                        if (item.fileUploadProgress) {
                            item.fileUploadProgress.progress = progress;
                        }
                    });
                }
                else {
                    valid = false;
                    item.errorMessage = "Udrejse tidspunkt og Hjemkost tidspunkt er ens - er der muligvis en fejl i din registrering.";
                }
            }
        };

        $ctrl.openUploadModal = function(contract) {
            $ctrl.selectedContractUpload = contract;
        }

        // error message
        $ctrl.messageError = function (item) {
            item.statusMessage = "Noget gik galt.Fejlkode: " + item.expenseMessageError + ".";
            item.messagerejected = true;
            item.expenseFormfade = true;


            $timeout(function () {
                return $timeout(function () {
                    item.notvisible = false;
                }, 3000);
            })
                .then(function () {
                    return $timeout(function () {
                        item.expenseFormfade = false;
                        item.expenceFormOpen = false;
                        // reset status message and form
                        item.statusMessage = false;
                        item.messagerejected = false;
                        resetExpense(item)
                        item.collapseDetapusgils = false;
                    }, 1000);
                });
        }
        $ctrl.$onInit = function () {
            User.getCurrent().then(function (userObj) {
                $ctrl.userCurrent = userObj;

                Contract.getApprovedAndRejectedContracts().then(function (contractObj) {
                    $ctrl.contracts = contractObj;

                    // og payment method?? den er jo på hver linje
                    $ctrl.loading = false;
                }, function (errorReponse) {
                    $ctrl.loading = false;
                });

            }, function (errorResponse) {
                $ctrl.loading = false;
            });
        }
    }
});
